
<script>
import { mapGetters, mapActions } from 'vuex';
import Booking from './../../store/modules/booking/types';
import Auth from './../../store/modules/auth/types';

export default {
  render: () => { return '' },
  name: 'BookingProvider',
  props: ['date'],
  created () {
    this.fetchData();
  },
  watch: {
    date () {
      this.fetchData()
    },
    logged () {
      this.fetchData()
    }
  },
  computed: {
    logged () {
      return this.loggedIn();
    },
    ...mapGetters('Booking', [Booking.getters.HAS_WEEK]),
    ...mapGetters('Auth', [Auth.getters.LOGGED_IN]),
  },
  methods: {
    ...mapActions('Booking', [Booking.actions.FETCH_WEEK]),
    fetchData () {
      if (this.date) {
        console.log('BookingProvider FETCH');
        this.fetchWeek(this.date);
      } else {
        throw new Error('BookingProvider: prop "date" not provided')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/providers/BookingProvider.vue